import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/es';
import 'moment/locale/it';
import 'moment/locale/fr';
import 'moment/locale/sr';
import 'moment/locale/ro';
import 'moment/locale/pl';
import 'moment/locale/el';
import 'moment/locale/ar';

import { toArabicIndicDigits } from './arabicDigits';
import { toIntlLocale } from './locales';

const MOMENT_LOCALE_BY_INTL: Record<string, string> = {
  'en-US': 'en-gb',
  en_US: 'en-gb',
  es: 'es',
  it: 'it',
  fr: 'fr',
  sr: 'sr',
  ro: 'ro',
  sq: 'en-gb',
  pl: 'pl',
  el: 'el',
  ar: 'ar',
};

/** Arabic UI uses full Gregorian month names — do not abbreviate (ينا/فبر/…). */
const ARABIC_GREGORIAN_MONTHS = [
  'يناير',
  'فبراير',
  'مارس',
  'أبريل',
  'مايو',
  'يونيو',
  'يوليو',
  'أغسطس',
  'سبتمبر',
  'أكتوبر',
  'نوفمبر',
  'ديسمبر',
];

moment.updateLocale('ar', {
  months: ARABIC_GREGORIAN_MONTHS.slice(),
  monthsShort: ARABIC_GREGORIAN_MONTHS.slice(),
  postformat: (formattedDate: string) => toArabicIndicDigits(formattedDate),
});

export const getMomentLocale = (i18nLanguage: string): string => {
  const intlLocale = toIntlLocale(i18nLanguage);
  return MOMENT_LOCALE_BY_INTL[intlLocale] ?? 'en-gb';
};

export const setMomentLocale = (i18nLanguage: string): void => {
  moment.locale(getMomentLocale(i18nLanguage));
};

export const formatFromNow = (
  date: string | Date,
  i18nLanguage: string
): string => moment(date).locale(getMomentLocale(i18nLanguage)).fromNow();
